import _ from 'lodash';
import axios from 'axios';
import Goal from 'core/Goal';
import AbstractCrudService from './AbstractCrudService';

export class GoalCrudService extends AbstractCrudService {
	constructor() {
		super('goals');
	}

	update(goal) {
		const id = _.get(goal, 'id');
		const financial_goal = _.get(goal, 'financialGoal');
		const product_price = _.get(goal, 'productPrice');
		const monthlyWorkdays = _.get(goal, 'monthlyWorkdays');
		const currency = _.get(goal, 'currency');

		const ctr_traffic = _.get(goal, 'ctr.traffic');
		const ctr_optin = _.get(goal, 'ctr.optin');
		const ctr_closerate = _.get(goal, 'ctr.closerate');

		const statement = _.get(goal, 'statement');
		const omissions = _.get(goal, 'omissions');
		const engagement = _.get(goal, 'engagement');

		const start_date = _.get(goal, 'startDate').format('YYYY-MM-DD');
		const end_date = _.get(goal, 'endDate').format('YYYY-MM-DD');

		const google_account = _.get(goal, 'googleAccount');
		const account_id = _.get(goal, 'accountId');
		const web_property_id = _.get(goal, 'webPropertyId');
		const profile_id = _.get(goal, 'profileId');

		return axios.put(`${this.apiUrl}/${id}`, {
			financial_goal,
			product_price,
			monthlyWorkdays,
			start_date,
			end_date,
			ctr_traffic,
			ctr_optin,
			ctr_closerate,
			statement,
			omissions,
			engagement,
			currency,
			google_account,
			account_id,
			web_property_id,
			profile_id
		});
	}

	create(goal) {
		const user_id = _.get(goal, 'userId');
		const financial_goal = _.get(goal, 'financialGoal');
		const product_price = _.get(goal, 'productPrice');
		const monthlyWorkdays = _.get(goal, 'monthlyWorkdays');

		const ctr_traffic = _.get(goal, 'ctr.traffic');
		const ctr_optin = _.get(goal, 'ctr.optin');
		const ctr_closerate = _.get(goal, 'ctr.closerate');

		const statement = _.get(goal, 'statement');
		const omissions = _.get(goal, 'omissions');
		const engagement = _.get(goal, 'engagement');

		const start_date = _.get(goal, 'startDate').format('YYYY-MM-DD');
		const end_date = _.get(goal, 'endDate').format('YYYY-MM-DD');

		const currency = _.get(goal, 'currency');

		const google_account = _.get(goal, 'googleAccount');
		const account_id = _.get(goal, 'accountId');
		const web_property_id = _.get(goal, 'webPropertyId');
		const profile_id = _.get(goal, 'profileId');

		return axios.post(`${this.apiUrl}`, {
			user_id,
			financial_goal,
			product_price,
			monthlyWorkdays,
			start_date,
			end_date,
			ctr_traffic,
			ctr_optin,
			ctr_closerate,
			statement,
			omissions,
			engagement,
			currency,
			google_account,
			account_id,
			web_property_id,
			profile_id
		});
	}

	async listByUserId(userId) {
		const { list, columns } = await this.fetchByField('user_id', userId);
		console.log(list, columns);
		return list.map(rawGoal => this.constructor.convert(rawGoal)(columns));
	}

	async deletegoalIds(userId,goal) {
 
		const { data } = await axios.get(`${'https://app.djuty.com/api/sbfunctions.php'}?a=2&userid=${userId}&goalid=${goal.id}`);
 		if(data && data.replyCode == 'success'){
			return data  ;
	    }
	}

	async get(goalId) {
		const { data } = await axios.get(`${this.apiUrl}/${goalId}`);
		return new Goal(data.id, data.user_id)
			.withTargets(data.financial_goal, data.product_price, data.currency, data.monthlyWorkdays)
			.withRange(data.start_date, data.end_date)
			.withCtr(data.ctr_traffic, data.ctr_optin, data.ctr_closerate)
			.withTexts(data.statement, data.omissions, data.engagement)
			.withGoogleAccount(
				data.google_account,
				data.account_id,
				data.web_property_id,
				data.profile_id
			);
	}

	static convert(rawGoal) {
		return columns => {
			const id = this.valueFrom(columns)('id')(rawGoal);
			const userId = this.valueFrom(columns)('user_id')(rawGoal);
			const startDate = this.valueFrom(columns)('start_date')(rawGoal);
			const endDate = this.valueFrom(columns)('end_date')(rawGoal);
			const financialGoal = this.valueFrom(columns)('financial_goal')(rawGoal);
			const productPrice = this.valueFrom(columns)('product_price')(rawGoal);
			const monthlyWorkdays = this.valueFrom(columns)('monthlyWorkdays')(rawGoal);

			const ctrTraffic = this.valueFrom(columns)('ctr_traffic')(rawGoal);
			const ctrOptin = this.valueFrom(columns)('ctr_optin')(rawGoal);
			const ctrCloseRate = this.valueFrom(columns)('ctr_closerate')(rawGoal);

			const statement = this.valueFrom(columns)('statement')(rawGoal);
			const omissions = this.valueFrom(columns)('omissions')(rawGoal);
			const engagement = this.valueFrom(columns)('engagement')(rawGoal);
			const currency = this.valueFrom(columns)('currency')(rawGoal);

			const googleAccount = this.valueFrom(columns)('google_account')(rawGoal);
			const accountId = this.valueFrom(columns)('account_id')(rawGoal);
			const webPropertyId = this.valueFrom(columns)('web_property_id')(rawGoal);
			const profileId = this.valueFrom(columns)('profile_id')(rawGoal);

			return new Goal(id, userId)
				.withTargets(financialGoal, productPrice, currency, monthlyWorkdays)
				.withRange(startDate, endDate)
				.withCtr(ctrTraffic, ctrOptin, ctrCloseRate)
				.withTexts(statement, omissions, engagement)
				.withGoogleAccount(googleAccount, accountId, webPropertyId, profileId);
		};
	}
}



// WEBPACK FOOTER //
// ./src/utils/GoalCrudService.js